<template>
  <div class="payment-receipt-create-top-grid">
    <ExpenseReceiptCreateDocumentSupplierCard
      :text="text"
      :document-type-options="documentTypeOptions"
      :supplier-options="supplierOptions"
      :selected-supplier="selectedSupplier"
      :collaborator-options="collaboratorOptions"
      :selected-collaborator="selectedCollaborator"
      :info="info"
      :currency="currency"
      :exchange-rate="exchangeRate"
      :supplier-pending-amount="supplierPendingAmount"
      :pay-to="payTo"
      @select-supplier="$emit('select-supplier', $event)"
      @select-collaborator="$emit('select-collaborator', $event)"
      @info-change="$emit('info-change', $event)"
      @update:currency="$emit('update:currency', $event)"
      @update:exchange-rate="$emit('update:exchange-rate', $event)"
    />

    <ExpenseReceiptCreatePaymentInfoCard
      :text="text"
      :info="info"
      :payment-form-options="paymentFormOptions"
      :payment-account-options="paymentAccountOptions"
      :currency="currency"
      @info-change="$emit('info-change', $event)"
    />
  </div>
</template>

<script>
import ExpenseReceiptCreateDocumentSupplierCard from '@/components/expenseReceipts/create/ExpenseReceiptCreateDocumentSupplierCard.vue';
import ExpenseReceiptCreatePaymentInfoCard from '@/components/expenseReceipts/create/ExpenseReceiptCreatePaymentInfoCard.vue';

export default {
  name: 'ExpenseReceiptCreateTopSection',
  components: {
    ExpenseReceiptCreateDocumentSupplierCard,
    ExpenseReceiptCreatePaymentInfoCard,
  },
  props: {
    text: {
      type: Object,
      required: true,
    },
    supplierOptions: {
      type: Array,
      default: () => [],
    },
    selectedSupplier: {
      type: Object,
      default: null,
    },
    collaboratorOptions: {
      type: Array,
      default: () => [],
    },
    selectedCollaborator: {
      type: Object,
      default: null,
    },
    paymentFormOptions: {
      type: Array,
      default: () => [],
    },
    paymentAccountOptions: {
      type: Array,
      default: () => [],
    },
    info: {
      type: Object,
      required: true,
    },
    currency: {
      type: String,
      default: 'MXN',
    },
    exchangeRate: {
      type: Number,
      default: 1,
    },
    payTo: {
      type: String,
      default: 'supplier',
    },
    supplierPendingAmount: {
      type: Number,
      default: 0,
    },
    documentTypeOptions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['select-supplier', 'select-collaborator', 'info-change', 'update:currency', 'update:exchange-rate'],
};
</script>

<style scoped>
.payment-receipt-create-top-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  align-items: start;
}

.payment-receipt-create-top-grid > * {
  min-height: 260px;
}

@media (max-width: 1200px) {
  .payment-receipt-create-top-grid {
    grid-template-columns: 1fr;
  }

  .payment-receipt-create-top-grid > * {
    min-height: 0;
  }
}
</style>
